import plur from 'plur';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Paragraph,
  type PlumaManagedModalProps,
} from '@customerio/pluma-components/react';
import type { AppUsage } from '@/services/db/app/entity';

export type AppDeleteInUseModalData = {
  appName: string;
  usage: AppUsage;
};

function usageSummary(usage: AppUsage): string {
  const { in_app_count: inAppCount, push_count: pushCount, total_count: totalCount } = usage;

  if (pushCount + inAppCount !== totalCount) {
    return `${totalCount} ${plur('message', totalCount)}`;
  }

  const counts: string[] = [];
  if (pushCount > 0) {
    counts.push(`${pushCount} push ${plur('message', pushCount)}`);
  }
  if (inAppCount > 0) {
    counts.push(`${inAppCount} in-app ${plur('message', inAppCount)}`);
  }
  return counts.join(' and ');
}

/** Deleting an app in use would break the messages sending through it, so this offers no way to go ahead. */
export function AppDeleteInUseModal({ data, onClose, modalState }: PlumaManagedModalProps<AppDeleteInUseModalData>) {
  const { appName, usage } = data;

  return (
    <Modal state={modalState} title="App can't be deleted" onClose={() => onClose()}>
      <ModalBody>
        <Paragraph>
          {usage.total_count > 0
            ? `"${appName}" is used by ${usageSummary(usage)}. To delete this app, remove it from these messages first.`
            : `"${appName}" is currently in use and can't be deleted.`}
        </Paragraph>
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" onClick={() => onClose()}>
          Got it
        </Button>
      </ModalFooter>
    </Modal>
  );
}
